import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Pages from './Navigator.page';
import Routes from './Navigator.route';
import { withCookies } from 'react-cookie';
import { compose } from 'ramda';
import withPendo from '../../hocs/withPendo';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const renderComponent = (props) => {
    return rest.isSignIn ? (
      <Component {...props} />
    ) : (
      <Redirect to={Routes.SignIn} />
    );
  };

  return <Route {...rest} render={renderComponent} />;
};

const PublicRoute = ({ component: Component, ...rest }) => {
  const renderComponent = (props) => {
    return !rest.isSignIn ? (
      <Component {...props} />
    ) : (
      <Redirect to={Routes.Dashboard} />
    );
  };

  return <Route {...rest} render={renderComponent} />;
};

const Navigator = (props) => {
  const { cookies } = props;
  const isSignIn = cookies.get('userInfo') && cookies.get('role');

  return (
    <>
      <Switch>
        <PrivateRoute
          component={Pages.Dashboard}
          exact={true}
          path={Routes.Main}
          isSignIn={isSignIn}
        />

        <Route component={Pages.Dashboard} path={Routes.Dashboard} />

        <Route
          component={Pages.PatientDocument}
          path={Routes.PatientDocument}
        />

        <PrivateRoute
          component={Pages.Billing}
          path={Routes.Billing}
          isSignIn={isSignIn}
        />

        <PublicRoute
          component={Pages.SignIn}
          path={Routes.SignIn}
          isSignIn={isSignIn}
        />

        <PublicRoute
          component={Pages.Register}
          path={Routes.Register}
          isSignIn={isSignIn}
        />

        <Route
          component={Pages.FormSubmission}
          exact={true}
          path={`${Routes.FormSubmission}/:formId/:checksum`}
        />

        <Route
          component={Pages.FormSubmission}
          exact={true}
          path={`${Routes.FormSubmission}/:formId/:checksum/:submissionId/:secureSubmissionId`}
        />

        <PublicRoute
          component={Pages.ForgotPassword}
          path={Routes.ForgotPassword}
          isSignIn={isSignIn}
        />

        <PublicRoute
          component={Pages.SetNewPassword}
          path={Routes.SetNewPassword}
          isSignIn={isSignIn}
        />

        <PrivateRoute
          component={Pages.ResetPassword}
          path={Routes.ResetPassword}
          isSignIn={isSignIn}
        />

        <PublicRoute
          component={Pages.VerifyIdentity}
          path={Routes.VerifyIdentity}
          isSignIn={isSignIn}
        />
      </Switch>
    </>
  );
};

export default compose(withCookies, withPendo)(Navigator);
